<template>
    <div class="page-content">

        <div id="soundlist" class="section grow bg-svg-lighthousesea">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Unlock more with Sleep Jar Premium!</h1>
                        <!--<p class="lead mb-5"><small class="opacity-50">Just $2.99/mo or $19.99/yr (US) before taxes and elegible discounts.</small></p>-->
                        <!--<p class="lead mb-10">Premium members enjoy</p>-->
                        <div class="mt-5 container">
                            <div class="row justify-content-around mb-5">
                                <!--
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-cloud-showers-heavy mr-2"></i>Additional sounds</span>
                                </div>
                                -->
                                <div class="col-md-6 mb-2">
                                    <span class="lead">
                                        <i class="fas fa-signal mr-2"></i>HD audio quality<br/>
                                        <span class="mt-2 lead btn btn-sm btn-light-outine">Hear the ripple of every ocean wave!</span><br/>

                                        <audio ref="hdDemoAudio" v-on:ended="audioEnded('hd')">
                                            <source :src="hdDemoAudioUrl"/>
                                        </audio>
                                        <span class="mt-2 lead btn-sound" :class="[buttonClass('hd'), colorClass('hd')]" v-on:click="togglePlayback('hd')"><i class="fas mr-2" :class="[buttonIconClass('hd')]"></i>{{buttonText('hd')}}</span>
                                    </span>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <span class="lead">
                                        <i class="fas fa-random mr-2"></i>Mix sounds together<br/>
                                        <span class="mt-2 lead btn btn-sm btn-light-outine">"Play rain and babbling brook"</span><br/>
                                        <audio ref="mixDemoAudio" v-on:ended="audioEnded('mix')">
                                            <source :src="mixDemoAudioUrl"/>
                                        </audio>
                                        <span class="mt-2 lead btn-sound" :class="[buttonClass('mix'), colorClass('mix')]" v-on:click="togglePlayback('mix')"><i class="fas mr-2" :class="[buttonIconClass('mix')]"></i>{{buttonText('mix')}}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row justify-content-around">
                                <!--
                                <div class="col-md-5 mb-5">
                                    <span class="lead"><i class="fas fa-cloud-showers-heavy mr-2"></i>Additional sounds</span>
                                </div>
                                -->
                                <div class="col-md-6 mb-2">
                                    <span class="lead">
                                        <i class="fas fa-unlock mr-2"></i>Access to all in-app content<br/>
                                        <span class="mt-2 lead btn btn-sm btn-light-outine">Listen to every sound, story, journey, and meditation we offer.</span>
                                    </span>
                                </div>
                                <div class="col-md-6 mb-2">
                                    <span class="lead">
                                        <i class="fas fa-clock mr-2"></i>Listen all night without gaps<br/>
                                        <span class="mt-2 lead btn btn-sm btn-light-outine">No sound gaps for a full 10 hours on Alexa!</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!--
                        <a href="https://www.amazon.com/dp/B092JRXVSX" target="_blank" class="btn btn-lg btn-light mt-10"><i class="fab mr-2 fa-amazon"></i>Click to subscribe on Amazon Alexa</a>

                        <p class="lead mt-3 mb-3 mt-2">or say</p>

                        <h3 class="title color-white mb-5 mt-0">"Alexa, ask Sleep Jar about premium"</h3>
                        -->

                        <!--
                        <p>In the two-step process, Alexa will tell you a brief overview of the benefits of Premium and ask if you're interested.</p>
                        <p>Say "yes" to hear the price (including any applicable discounts) and be asked if you would like to sign up.</p>
                        -->

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">How much does Sleep Jar Premium cost?</h4>
                            <p>Sleep Jar Premium is $2.99/mo (US) before taxes or promotional discounts. Pricing may vary by platform and region.<br/>That's more affordable than a modern sound machine or a Starbucks coffee!</p>
                        </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">How do I purchase Sleep Jar Premium?</h4>
                            <p><span class="badge badge-light mr-2">Alexa</span>Just say <b>"Alexa, ask Sleep Jar about premium"</b>.</p>
                            <p><span class="badge badge-light mr-2">Android</span>Go to the settings page then tap "Upgrade to Premium".</p>
                            <p><span class="badge badge-light mr-2">iOS</span>Go to the settings page then tap "Upgrade to Premium".</p>
                            <p><span class="badge badge-light mr-2">Fire TV</span>Premium is not yet available on Fire TV.</p>
                        </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">How do I enable premium audio quality and extended loops?</h4>
                            <p><span class="badge badge-light mr-2">Alexa</span>Premium audio quality and extended loops are automatically enabled with our Premium Membership plan.</p>
                            <p><span class="badge badge-light mr-2">Android</span>Premium audio quality on Android is automatically enabled with an active Sleep Jar Premium subscription.</p>
                            <p><span class="badge badge-light mr-2">iOS</span>Premium audio quality on iOS is automatically enabled with an active Sleep Jar Premium subscription.</p>
                            <p><span class="badge badge-light mr-2">Fire TV</span>Premium is not yet available on Fire TV.</p>
                        </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">How do I mix sounds together?</h4>
                            <p><span class="badge badge-light mr-2">Alexa</span>Say <b>"Alexa, open Sleep Jar"</b>. When asked which sound you would like, say something like <b>"play rain sounds and ocean waves"</b>.</p>
                            <p><span class="badge badge-light mr-2">Android</span>Mix sounds by tapping the "+" button while a sound is playing.</p>
                            <p><span class="badge badge-light mr-2">iOS</span>Mix sounds by tapping the "+" button while a sound is playing.</p>
                            <p><span class="badge badge-light mr-2">Fire TV</span>This feature is not yet available on Fire TV.</p>
                        </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">Does my Premium membership work across platforms?</h4>
                            <p>Yes! Premium membership works across Android, iOS, and Alexa (linking required). You can link Alexa to your Sleep Jar account by opening the settings view in Sleep Jar for Android or iOS and tapping "Link to Alexa".</p>
                        </div>

                        <p class="lead mt-10"><small class="opacity-50">First-time subscribers may be offered a free trial. Stories, meditations, and journeys are not yet available on Fire TV.</small></p>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
export default {
    data () {
        return {
            "is_playing": {
                "hd": false,
                "mix": false
            }
        };
    },
    name: 'premium',
    metaInfo: {
        title: 'Premium Membership',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'Sleep Jar® Premium offers longer loops, the best audio quality, and the ability to mix sounds together. Click to learn more.'
            }
        ]
    },
    methods: {
        "stopAudio": function(type = "mix"){
            this.is_playing[type] = false;
            this.$refs[type + "DemoAudio"].pause();
        },
        "startAudio": function(type = "mix"){
            this.is_playing[type] = true;
            this.$refs[type + "DemoAudio"].currentTime = 0;
            this.$refs[type + "DemoAudio"].play();
        },
        "audioEnded": function(type = "mix"){
            this.stopAudio(type);
        },
        "togglePlayback": function(type = "mix"){
            if(this.is_playing[type]){
                // stop it
                this.stopAudio(type);
            }else{
                // start it
                this.startAudio(type);
            }
        },
        buttonClass: function(type = "mix"){
            return {
                "btn": true,
                "btn-sm": true,
                "btn-outline-light": !this.is_playing[type],
                "btn-light": this.is_playing[type]
            };
        },
        buttonIconClass: function(type = "mix"){
            return {
                "fa-play": !this.is_playing[type],
                "fa-stop": this.is_playing[type]
            };
        },
        colorClass: function(type = "mix"){
            return {
                "color-white": !this.is_playing[type],
                "color-purple": this.is_playing[type]
            };
        },
        buttonText: function(type = "mix"){
            return this.is_playing[type] ? "Stop" : "Demo";
        },
    },
    computed: {
        hdDemoAudioUrl: function(){
            return "/audio/hd/hd.mp3";
        },
        mixDemoAudioUrl: function(){
            return "/audio/hd/mix.mp3";
        },
    },
    components: {
    },
    mounted(){
        EventBus.$on("audio-stop", function(index){
            this.$refs.previews[index].stopAudio();
        }.bind(this));
    }
}
</script>
